// Which Sentry environment bucket this build reports into.
//
// This used to be `process.env.NODE_ENV`, which CRA sets to "production" for ANY production
// build — so staging events landed in the same bucket as real production traffic and could
// not be filtered out or excluded from alerting (QA, 2026-07-20; confirmed on live events,
// which carry environment=production from stage-panel.bankcow.io).
//
// Derived from the host rather than a new build-time variable because the REACT_APP_* values
// are injected by deploy config outside this repo: a new variable would silently stay unset
// and change nothing. REACT_APP_SENTRY_ENV is still honoured first if anyone does set one.
export const resolveSentryEnvironment = ({ hostname = '', nodeEnv, override } = {}) => {
  if (override) return override
  if (nodeEnv && nodeEnv !== 'production') return nodeEnv

  const host = String(hostname).toLowerCase()
  if (host === 'localhost' || host === '127.0.0.1' || host === '::1' || host.endsWith('.local')) {
    return 'local'
  }
  // stage-panel.bankcow.io — and tolerate the other shapes a staging host usually takes
  if (/(^|[.-])(stage|staging)([.-]|$)/.test(host)) return 'staging'

  return 'production'
}
